import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Grid
} from '@mui/material';

const Footer = () => {
  return (
    <Box
      sx={{
        bgcolor: '#111',
        color: '#fff',
        py: { xs: 5, md: 8 },
        mt: 8
      }}
    >
      <Container maxWidth="lg">

        <Grid container spacing={4}>

          {/* Company */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography fontWeight={700}>
              Kavya Institute Of Fire & Industrial Safety
            </Typography>

            <Typography variant="body2" mt={1}>
              ISO 9001:2015 Certified &
              Govt. of India Registered Organization.
            </Typography>

            <Typography
              variant="body2"
              sx={{ mt: 2 }}
            >
              A Unit of
              <br />
              KAVYARG GLOBAL INDIA PRIVATE LIMITED
            </Typography>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography fontWeight={700}>
              Quick Links
            </Typography>

            <Typography
              component={Link}
              to="/"
              sx={{
                display: 'block',
                color: '#fff',
                textDecoration: 'none',
                mt: 1
              }}
            >
              Home
            </Typography>

            <Typography
              component={Link}
              to="/courses"
              sx={{
                display: 'block',
                color: '#fff',
                textDecoration: 'none'
              }}
            >
              Courses
            </Typography>

            <Typography
              component={Link}
              to="/ourproducts"
              sx={{
                display: 'block',
                color: '#fff',
                textDecoration: 'none'
              }}
            >
              Safety Products
            </Typography>

            <Typography
              component={Link}
              to="/branches"
              sx={{
                display: 'block',
                color: '#fff',
                textDecoration: 'none'
              }}
            >
              Our Branches
            </Typography>

            <Typography
              component={Link}
              to="/contact"
              sx={{
                display: 'block',
                color: '#fff',
                textDecoration: 'none'
              }}
            >
              Contact
            </Typography>
          </Grid>

          {/* Contact */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography fontWeight={700}>
              Contact
            </Typography>

            <Typography variant="body2" mt={1}>
              +91-7979-966901
            </Typography>

            <Typography variant="body2">
              kifisrg@gmail.com
            </Typography>

            <Typography variant="body2" sx={{ mt: 1 }}>
              India
            </Typography>
          </Grid>

          {/* Certifications */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography fontWeight={700}>
              Certifications & Registration
            </Typography>

            <Typography variant="body2" mt={1}>
              ✓ ISO 9001:2015 Certified
            </Typography>

            <Typography variant="body2">
              ✓ Govt. of India Registered
            </Typography>

            <Typography variant="body2">
              ✓ UDYAM Registered
            </Typography>

            <Typography
              variant="body2"
              sx={{
                mt: 2,
                wordBreak: 'break-word'
              }}
            >
              <strong>CIN:</strong>
              <br />
              U85499DC2026PTC471131
            </Typography>

            <Typography
              variant="body2"
              sx={{ mt: 1 }}
            >
              <strong>UDYAM:</strong>
              <br />
              UDYAM-BR-35-0003536
            </Typography>
          </Grid>

        </Grid>

        <Box
          sx={{
            borderTop: '1px solid rgba(255,255,255,0.15)',
            mt: 5,
            pt: 3
          }}
        >
          <Typography
            textAlign="center"
            variant="caption"
            color="gray"
          >
            © {new Date().getFullYear()} Kavya Institute Of Fire &
            Industrial Safety. All Rights Reserved.
          </Typography>
        </Box>

      </Container>
    </Box>
  );
};

export default Footer;